const state = {
  row: null,
  selected: [],
  scores: [0, 0, 0],
  result: 0,
  product: null,
  selects: [0, 0, 0, 0],
  shouldStop: false,
  videoStream: null
}
const mutations = {
}
const actions = {

}
const getters = {

}

export default {
  state,
  mutations,
  actions,
  getters
}
